<template>
  <div class="content">
    <div class="rotation">
      <div class="rotation_content">
        <div class="search">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="">
              <el-select v-model="formInline.period_id" filterable placeholder="请选择期次" @change="changePeriod">
                <el-option
                  v-for="item in periodArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-select v-model="formInline.group_id" filterable placeholder="班级(请先选期次)">
                <el-option
                  v-for="item in classArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item  label="">
              <el-input  v-model="formInline.realname" placeholder="请输入学员姓名" class="select_input"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-date-picker
                v-model="formInline.begin_time"
                type="date"
                placeholder="签订开始日期">
              </el-date-picker> 
              -
              <el-date-picker
                v-model="formInline.end_time"
                type="date"
                placeholder="签订结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="">
              <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
            <el-form-item label="">
              <el-button type="warning" @click="onReset">重置</el-button>
            </el-form-item>
            <el-form-item label="">
              <el-button type="primary"  @click="exportTable">导出协议书</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="table">
          <el-table
            ref="multipleTable"
            border
            :data="tableData"
            @selection-change="handleSelectionChange"
            min-height="350px"
            :header-cell-style="{background:'#f5f7fa',color:'#606266'}"
            style="width: 100%">
            <el-table-column
                type="selection"
                fixed
                width="40">
            </el-table-column>
            <el-table-column
              label="姓名"
             >
              <template slot-scope="scope">{{ scope.row.realname }}</template>
            </el-table-column>
            <el-table-column
              label="状态"
             >
              <template slot-scope="scope">
                <span class="nopass" v-if="scope.row.sign_status ===0">未签</span>
                <span class="onpass" v-else-if="scope.row.sign_status ===1">已签</span>
              </template>
            </el-table-column>
            <el-table-column
              label="签订时间"
             >
              <template slot-scope="scope">{{ scope.row.create_time }}</template>
            </el-table-column>
            <el-table-column
              label="签名图"
             >
              <template slot-scope="scope">
                <img v-show="scope.row.image" :src="scope.row.image" class="student_avatar">
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="table_pagination">
          <el-pagination
            background
            @prev-click="prevClick"
            @next-click="nextClick"
            @current-change="currentClick"
            layout="prev, pager, next"
            :total="total"
            :page-size="page_size">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { total,page, page_size} from '../../config'
  export default{
    name:'arageement',
    data(){
      return {
        tableData: [],
        formInline: {
          period_id:'',
          group_id:'',
          realname:'',
          begin_time:'',
          end_time:''
        },
        deleteList: [],
        total,
        page,
        page_size,
        periodArr:[],
        classArr:[],
        url:window.location.origin 
      }
    },
    created(){

      let periodparams = {
        period_name : '',
        category:''
      }
      this.obtainPeriod(periodparams)
    },
    mounted(){
      
    },
    methods:{
      getinfor(params){
        this.$api.user.agreementList(params)
          .then(res=>{
              if(res.code === 0){
                this.tableData = res.result.result
                this.total = res.result.total
              }else if(res.code === 1010){
                this.tableData = []
                this.total = 0
              }
          }) 
      },
      obtainPeriod(params){
        this.$api.user.periodSelectList(params)
        .then(res=>{
          if(res.code === 0){
            this.periodArr = res.result
            if(this.periodArr[0]){
              this.formInline.period_id = this.periodArr[0].id
              this.formInline.group_id = ''
              this.classArr = []
              this.getGroup({period_id: this.formInline.period_id})
            }
          }
        }) 
      },
      changePeriod(){
        this.formInline.group_id = ''
        this.classArr = []
        this.getGroup({period_id: this.formInline.period_id})
      },
      getGroup({period_id}){
        this.$api.user.classSelectList({
          period_id : period_id
        })
        .then(res=>{
          if(res.code === 0){
            this.classArr = res.result
            if(this.classArr[0]){
              this.formInline.group_id = this.classArr[0].id
            }
          }
          this.onSubmit()
        }) 
      },
      exportTable(){
        if(this.formInline.group_id != ''){
          let token = JSON.parse(localStorage.getItem('res')).token
          let ids = ''
          if(this.deleteList.length > 0 ){
            for(let i = 0; i < this.deleteList.length;i++){
              if(i < this.deleteList.length-1){
                ids += this.deleteList[i] + ','
              }else{
                ids += this.deleteList[i]
              }
            }
          }
          let a = document.createElement('a');
          a.href = this.url + '/manager/agreement/export?token='+token + '&group_id='+this.formInline.group_id+ '&student_id='+ids
          
          a.download = '签名协议书'
          a.click()
        }else{
          this.$message.error('请选择要导出的学员或班级')
        }
      },
      handleSelectionChange(value){
        let arr = value
        this.deleteList = []
        for(let i = 0;i < arr.length ; i++){
            this.deleteList.push(arr[i].id)
        }
      },
      onSubmit() {
        let params = {
          period_id:this.formInline.period_id,
          group_id:this.formInline.group_id,
          begin_time:this.formInline.begin_time,
          end_time:this.formInline.end_time,
          realname:this.formInline.realname,
          page:this.page,
          page_size:this.page_size
        }
        this.getinfor(params)
      },
      onReset(){
        if( this.formInline.begin_time || this.formInline.end_time || this.formInline.realname){
          this.formInline.begin_time = ''
          this.formInline.end_time = ''
          this.formInline.realname = ''
        }
        let periodparams = {
          period_name : '',
          category:''
        }
        this.obtainPeriod(periodparams)
      },
      currentClick(val){
      let params = {
          period_id:this.formInline.period_id,
          group_id:this.formInline.group_id,
          begin_time:this.formInline.begin_time,
          end_time:this.formInline.end_time,
          realname:this.formInline.realname,
          page:val,
          page_size:this.page_size
        }
      this.getinfor(params)
    },
    nextClick(val){
      let params = {
          period_id:this.formInline.period_id,
          group_id:this.formInline.group_id,
          begin_time:this.formInline.begin_time,
          end_time:this.formInline.end_time,
          realname:this.formInline.realname,
          page:val,
          page_size:this.page_size
        }
      this.getinfor(params)
    },
    prevClick(val){
      let params = {
          period_id:this.formInline.period_id,
          group_id:this.formInline.group_id,
          begin_time:this.formInline.begin_time,
          end_time:this.formInline.end_time,
          realname:this.formInline.realname,
          page:val,
          page_size:this.page_size
        }
      this.getinfor(params)
    },
    },
    watch:{
    }
  }
</script>
<style scoped lang="scss">
  @import '../../assets/scss/content.scss';
  @import '../../assets/scss/student.scss';
</style>